import { handleActions } from 'redux-actions';
import { types } from './actions';

const initialState = {
  findVisitorsWithCriminalRecordIsInProgress: false,
  findVisitorsWithCriminalRecordHasFailed: false,
  findVisitorsWithCriminalRecordSuccess: false,
  apiError: null,
  totalElements: 0,
  totalPages: 0,
  list: []
};

const reducer = handleActions(
  {
    //find
    [types.findVisitorsWithCriminalRecordInProgress]: state => {
      return {
        ...state,
        findVisitorsWithCriminalRecordIsInProgress: true,
        findVisitorsWithCriminalRecordHasFailed: false,
        findVisitorsWithCriminalRecordSuccess: false,
        apiError: null
      };
    },
    [types.findVisitorsWithCriminalRecordSuccess]: (state, action) => {
      return {
        ...state,
        findVisitorsWithCriminalRecordIsInProgress: false,
        findVisitorsWithCriminalRecordHasFailed: false,
        findVisitorsWithCriminalRecordSuccess: true,
        apiError: null,
        list: action.payload.content,
        totalElements: action.payload.totalElements,
        totalPages: action.payload.totalPages
      };
    },
    [types.findVisitorsWithCriminalRecordFailed]: (state, action) => {
      return {
        ...state,
        findVisitorsWithCriminalRecordIsInProgress: false,
        findVisitorsWithCriminalRecordHasFailed: true,
        findVisitorsWithCriminalRecordSuccess: false,
        apiError: action.payload.apiError
      };
    }
  },
  initialState
);

export default reducer;
